// gtm-boot.js — G4: Google Tag Manager loader (classic script, runs synchronously in <head>).
// The old Index.cshtml inline snippet, ported to a file (hard rule 2: no inline scripts) and
// configured from its own data-* attributes. Deliberately NOT a module: modules are deferred,
// and the container must start before the page's own scripts push events.
(function () {
  var me = document.currentScript;
  var id = me && me.getAttribute('data-gtm-id');
  if (!id) return;

  window.dataLayer = window.dataLayer || [];
  // Consent Mode v2. gtag() is the documented way to feed consent to GTM and must push the
  // `arguments` object itself (not an array) — that is what the container recognises.
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = window.gtag || gtag;

  // "granted" reproduces today's live behaviour (no default set, everything fires on load) while
  // making the state EXPLICIT; G3 flips Analytics:ConsentDefault to "denied" and its banner calls
  // gtag('consent', 'update', {...}).
  var state = me.getAttribute('data-consent-default') === 'denied' ? 'denied' : 'granted';
  gtag('consent', 'default', {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state
  });

  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
  var s = document.createElement('script');
  s.async = true;
  s.src = 'https://www.googletagmanager.com/gtm.js?id=' + encodeURIComponent(id);
  var first = document.getElementsByTagName('script')[0];
  first.parentNode.insertBefore(s, first);
})();
